<template>
  <v-data-table
    v-bind="$attrs"
    v-on="$listeners"
    hide-default-footer
    :items-per-page="10"
    :page.sync="currentPage"
    :fixed-header="true"
    :class="{ 'top-operation-data-table': isNoWrapMode }"
  >
    <template v-for="(value, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data" />
    </template>
    <template
      v-if="!('top' in this.$scopedSlots)"
      v-slot:top="{ pagination, options, updateOptions }"
    >
      <v-data-footer
        :pagination="pagination"
        :options="options"
        :items-per-page-options="[5, 10, 15, -1]"
        @update:options="updateOptions"
        items-per-page-text="$vuetify.dataTable.itemsPerPageText"
      />
    </template>
  </v-data-table>
</template>

<script>
/**
 * cssのmax_heightを使って高さを可変にしている
 */
export default {
  inheritAttrs: false,
  props: {
    // 行の表示モード
    // wrap: 折り返しあり, nowrap: 折り返しなし
    dispMode: {
      default: "wrap"
    }
  },
  data: () => ({
    currentPage: 1
  }),
  computed: {
    /**
     * nowrapモードとして設定されているか
     */
    isNoWrapMode() {
      return this.dispMode === "nowrap";
    }
  },
  methods: {
    /**
     * ページを1ページ目に戻す
     */
    resetPage() {
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.theme--light.v-data-table .v-data-footer {
  border-top: none;
}
</style>

<style>
/* 高さ制限用 */
.top-operation-data-table .v-data-table__wrapper {
  max-height: 528px; /* header:48 + data:48 x10 */
}
/* 全選択チェックボックス非表示 */
.v-data-table-header .v-simple-checkbox {
  display: none;
}
</style>
